// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1813f91f","732":"b8fa81ca","977":"f71302b1"}[chunkId] + ".chunk.js";
};